import React from 'react';
import logoVID from './logo-vid.svg';
import logoELFLA from './logo-elfla.svg';
import logoLLKC from './logo-llkc.svg';
import css from './index.module.css';

export default function Partners() {
  return (
    <div className={css['partners']}>
      <div className={css['content']}>
        <img src={logoVID} alt="" className={css['logo']} />
        <img src={logoELFLA} alt="" className={css['logo']} />
        <img src={logoLLKC} alt="" className={css['logo']} />
      </div>
    </div>
  );
}
